

  
  
    <div *ngIf="!sucess">
        <div class="subscribe-container">
            <div class="subscribe">
            <form name="form" (ngSubmit)="subscribe.form.valid && onSubmit()" #subscribe="ngForm" novalidate>
              <div class="row">
                <div class="col-md-5">
                  <div class="group">
                    <i class="fa fa-envelope-open-o fa-3x" aria-hidden="true"></i>
                    <p>Get Discount Vouchers, Secret Deals, Sale Previews &amp; Much More on Your Email!</p>
                  </div>
                </div>
                <div class="col-md-5">
                  <input type="text" placeholder="Enter Email Address" name="email" [(ngModel)]="model.email" #email="ngModel"
                    [ngClass]="{ 'is-invalid': subscribe.submitted && email.invalid }" required email>
                  <div *ngIf="subscribe.submitted && email.invalid" class="invalid-feedback">
                    <div *ngIf="model.email.errors.required">Email is required</div>
                    <div *ngIf="model.email.errors.email">Email must be a valid email address</div>
                  </div>
                </div>
        
                <div class="col-md-2">
                  <button class="btn-subscribe">Subscribe</button>
                 
                </div>
        
        
        
              </div>
            </form>
            </div> 
           </div>
            
      
      </div>
      <div *ngIf="sucess" >
       
          <div class="subscribe-container">
              <div class="subscribe-sucess">
              <div class="sucess">
                <i class="fa fa-check-circle-o fa-3x" aria-hidden="true"></i>
                <p>Thank You!</p>
              </div>
              <p> You are successfully subscribed.</p>
              </div>
              </div>
   </div>
